import * as React from 'react';

import { t } from 'utils/language';

import ActionButton from 'components/buttons/action-button/ActionButton';
import SVGIcon from 'components/svg-icon/SVGIcon';
import { ModalFrame, ModalFrameFooter, ModalFrameMessage, ModalOpener } from 'components/modal';

type Props = {
  open: boolean,
  invitedUser: {
    email: string
  },
  onClose: () => void
};

export class InviteMembersSuccessModal extends React.PureComponent<Props> {
  handleClose = () => {
    this.props.onClose();
  };

  render() {
    const { open } = this.props;
    const invitedUser = this.props.invitedUser || {};

    return (
      <ModalOpener
        open={open}
        width="small"
        onClose={this.handleClose}
      >
        <ModalFrame
          title={t('invite_team_members_success_modal_title')}
          data={{ qa: 'invite-team-member-success-modal' }}
        >
          <ModalFrameMessage
            message={t('invite_team_members_success_modal_message', { email: invitedUser.email })}
          />
          <ModalFrameFooter>
            <SVGIcon
              name="email-sent"
              width={240}
              height={160}
            />
          </ModalFrameFooter>
          <ModalFrameFooter>
            <ActionButton onClick={this.handleClose}>
              {t('close_action_button')}
            </ActionButton>
          </ModalFrameFooter>
        </ModalFrame>
      </ModalOpener>
    );
  }
}

export default InviteMembersSuccessModal;
